module.exports = __webpack_public_path__ + "img/inversion_allianz.3f001f13.svg";